import * as service from './patrons.service'
export default {
  data() {

    return {
      compliance_columns: ['FirstName', 'LastName', 'Actions'],
      optionstable: {
        headings: {
          FirstName: 'First Name',
          LastName: 'Last Name',

          Actions: ''
        },
        labelPosition: 'top',

        /*    isediting: false,
         EditableColID: '',
         role: '',*/
        // sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: [],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },

      addAccount: {
        Address: '',
        AlternativeEmail: '',
        CellNumber: '',
        City: '',
        FirstName: '',
        HomeNumber: '',
        Id: '',
        LastName: '',
        LocationId: '',
        MiddleName: '',
        Notes: '',
        PrimaryContactName: '',
        PrimaryContactPhone: '',
        PrimaryContactRelation: '',
        PrimaryEmail: '',
        SecondaryContactName: '',
        SecondaryContactPhone: '',
        SecondaryContactRelation: '',
        State: '',
        ZipCode: ''

      },
      addComplianceCopy: {},
      rules: {

        FirstName: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        LastName: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        PrimaryEmail: [

          {
            type: 'email',
            required: true,
            message: 'This field is required'
          },

        ],
        PrimaryContactName: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        PrimaryContactPhone: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        PrimaryContactRelation: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
      },
      Members: [],
      locationName: '',
      modalTitle: '',
      locationId: 25,
      isediting: false,
      isaddding: false

    }
  },
  mounted() {
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if (context.locationId) {
        context.GetAllMembers(context.locationId)
      }

      // alert(JSON.stringify(data))

    })

    //this.GetAllMembers(this.locationId)

  },

  methods: {

    addCompliancevit() {
      this.isaddding = true

      this.addAccount = {
        Address: '',
        AlternativeEmail: '',
        CellNumber: '',
        City: '',
        FirstName: '',
        HomeNumber: '',
        Id: '',
        LastName: '',
        LocationId: '',
        MiddleName: '',
        Notes: '',
        PrimaryContactName: '',
        PrimaryContactPhone: '',
        PrimaryContactRelation: '',
        PrimaryEmail: '',
        SecondaryContactName: '',
        SecondaryContactPhone: '',
        SecondaryContactRelation: '',
        State: '',
        ZipCode: ''

      }

    },
    showCompliancevit() {
      this.isaddding = false
      this.isediting = false
    },
    ShowAddKudos() {
      let context = this

      setTimeout(function () {
        context.$refs['addKudos'].resetFields()
      }, 10)
      this.isediting = false
      $('#Addkudosmodel').modal('show')
      this.modalTitle = 'Create Kudos'
      this.addKudos = deepcopy(this.kudoBackup)
    },

    GetAllMembers(locationId) {
      let context = this
      loader.startLoader()
      service.GetAllMembers(locationId).then(function (response) {

        if (response && response != null) {
          context.Members = response
          tooltip.startTooltip()
        } else {

          context.Members = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetMemberDetails(id) {
      let context = this
      loader.startLoader()
      service.GetMemberDetails(id).then(function (response) {

        if (response && response != null) {
          context.addAccount = response


        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    del: function (data) {
      var ID = data.row.Id
      let context = this
      var opts = {message: 'Are you sure you want to delete ' + data.row.FirstName + ' ' + data.row.LastName + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteMembershipRow.bind(null,ID))
    },
    deleteMembershipRow(ID) {
      var context = this;
      loader.startLoader()
      service.DeleteMember(ID).then(function (response) {
        context.GetAllMembers(context.locationId)
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
      }, 
      (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    
    },

    cancelpopup: function () {
      $('#Addkudosmodel').modal('hide')
    },

    editcol: function (data) {

      var ID = data.row.Id
      let context = this
      context.EditableColID = ID

      context.GetMemberDetails(ID)
      context.isediting = true

    },

    AddAccount(formName) {

      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          context.addAccount['LocationId'] = context.locationId

          service.AddMember(context.addAccount).then(function (response) {

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Personnel details Created',
              type: 'success'
            })
            context.GetAllMembers(context.locationId)
            context.isediting = false
            context.isaddding = false

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'MEMBERSHIP - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    UpdateAccount(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()
          context.addAccount['LocationId'] = context.locationId

          // context.addCompliance['Id'] =
          service.UpdateMember(context.addAccount).then(function (response) {

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Personnel details Updated',
              type: 'success'
            })
            context.GetAllMembers(context.locationId)
            context.isediting = false
            context.isaddding = false

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'MEMBERSHIP - 2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {

    isediting: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    isaddding: function (val) {

      this.$router.app.$emit('sidebar_hide', val)
    }


  },


}



// WEBPACK FOOTER //
// ./src/pages/Patrons/memberships.controller.js